import {memoize, groupBy, lowerCase, pluralize, createSelector} from 'helpers';
import {id, context} from 'store/common';
import {parents} from './parents';
import {user} from 'store/session';

const relations = createSelector(
  [ state => state.relations ],
  ( relations ) => groupBy(relations, ({ modelType, modelId }) => {
    return modelType.replace('task', 'activity').replace('journal', 'diary') + modelId;
  }),
);

export const getCollaboration = createSelector(
  [ user, relations, parents ],
  ( user, relations, parents ) => memoize(({ id, context = '' }) => {
    context = context.replace(/routines|habits/, 'activities');
    const match = relations[pluralize(context, 1) + id] || relations['goal' + parents[id]];
    const self = match?.find(item => item.email?.toLowerCase() === user.email?.toLowerCase());
    if (match && self) {
      return {
        assigned: match.find(relation => /Assigner/.test(relation.type)) && self.type == 'Owner',
        relations: match,
        self,
        shareable: self?.type == 'Owner',
      }
    }
  }, JSON.stringify)
);

export const isEditable = createSelector(
  [getCollaboration],
  (getCollaboration) => ({id, context = 'activities'}) => {
    const collaboration = getCollaboration({id, context});
    return !collaboration || !collaboration?.self.type.match(/Share/);
  }
);

export const collaboration = createSelector(
  [ getCollaboration, id, context ],
  ( getCollaboration, id, context ) => getCollaboration({id, context}),
);

export const editable = createSelector(
  [ collaboration ],
  ( collaboration ) => !collaboration || !collaboration?.self.type.match(/Share/)
);

export const role = ({ type = '' } = {}) =>
  type.replace('Assigner', '')
      .replace('Collaborate', 'Collaborating')
      .replace(/\bShare\b/, 'Shared');
